import Vue from 'vue';
import Vuetify from 'vuetify/lib';
Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            dark: {
                primary: '#0388e5', // #E53935
                secondary: '#485460', // #FFCDD2
            },
            light: {
                primary: '#FF6A2A',
                secondary: '#485460',
                success: '#FF6A2A',
                info: '#FF6A2A',
                warning: '#FF6A2A',
                error: '#FF5252', // Keeping error red for usability unless otherwise requested
            },
        },
    },
});
